module.exports = __webpack_public_path__ + "img/logo.1193b99c.svg";